import { Component, Input, OnChanges } from '@angular/core';
import { TIconName } from '@monorepo/types';

import * as _ from 'lodash';

@Component({
  selector: 'monorepo-zf-icon',
  template: `<i class="zf-icon" [ngClass]="iconClass"></i>`,
  styleUrls: ['zf-icon.scss'],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class ZFIcon implements OnChanges {
  @Input() iconName: TIconName = 'activation-logo';
  @Input() isActive = false;
  @Input() iconClasses: string[] = [];

  public iconClass: string[] = [];

  private zfIcon = 'zf-icon--';

  ngOnChanges() {
    this.iconClass = [];
    const iconPreDefinedClass = this.getIconClass(this.iconName, this.isActive);
    this.iconClass.push(iconPreDefinedClass);
    if (this.iconClasses) {
      // TODO: Can add support for string or array for legacy support
      this.iconClass.push(...this.iconClasses);
    }
    this.iconClass = _.compact(this.iconClass);
  }

  private getIconClass(iconName: TIconName, active: boolean) {
    let zfIconClass = this.zfIcon;

    if (active) {
      zfIconClass += 'active--';
    }

    return zfIconClass + iconName;
  }
}
